// theirs
import React, { useEffect } from 'react'
import { motion, useAnimation } from 'framer-motion'
import classNames from 'classnames'

// ours
import { CollectionContext, CollectionContextInterface } from '../../../App'
import { ContentDataModel } from '../../../interfaces'
import { nextChapterBaseClass, StyledNextChapter } from './style'
import IconArrow from '../../Icons/IconArrow'

export interface NextChapterProps {
    className?: string
    testId?: string
    content: ContentDataModel
    animationControls?: any
    collectionContext?: CollectionContextInterface
}

const NextChapter = ({
    className,
    testId,
    content,
    animationControls,
}: NextChapterProps) => {
    const collectionContext = React.useContext(CollectionContext)

    const chapterDurationShort = 0.4
    const chapterDelayShort = 0.3
    const chapterDelayMedium = 0.6
    const chapterDelayLong = 1

    const chapterTitle = {
        hidden: {
            opacity: 0,
            y: 10,
        },
        show: {
            opacity: 1,
            y: 0,
            transition: {
                delay: chapterDelayShort,
                duration: chapterDurationShort,
                ease: [0.455, 0.03, 0.515, 0.955],
            },
        },
    }
    const chapterSubtitle = {
        hidden: {
            opacity: 0,
            y: 10,
        },
        show: {
            opacity: 1,
            y: 0,
            transition: {
                delay: 0,
                duration: chapterDurationShort,
                ease: [0.455, 0.03, 0.515, 0.955],
            },
        },
    }
    const chapterLink = {
        hidden: {
            opacity: 0,
            y: 10,
        },
        show: {
            opacity: 1,
            y: 0,
            transition: {
                delay: chapterDelayMedium,
                duration: chapterDurationShort,
                ease: [0.455, 0.03, 0.515, 0.955],
            },
        },
    }
    const chapterArrow = {
        hidden: {
            opacity: 0,
            scaleX: 0.1,
            scaleY: 0.8,
            x: -10,
        },
        show: {
            opacity: 1,
            x: 0,
            scaleX: 1,
            scaleY: 1,
            transition: {
                delay: chapterDelayLong,
                duration: chapterDurationShort,
                ease: [0.455, 0.03, 0.515, 0.955],
            },
        },
    }
    const chapterAnimationControls = useAnimation()

    useEffect(() => {
        if (collectionContext?.isScrolledToBottom) {
            chapterAnimationControls.start('show')
            console.log('NextChapter: isScrolledToBottom ===', true)
        }
    }, [chapterAnimationControls, collectionContext?.isScrolledToBottom])

    return (
        <StyledNextChapter
            className={classNames(nextChapterBaseClass, className)}
            data-testid={testId}
            content={content}
        >
            <div className="content-outer">
                <div className="content-inner">
                    {content.contentNextChapter?.contentNextChapterSubTitle && (
                        <motion.div
                            initial="hidden"
                            animate={chapterAnimationControls}
                            variants={chapterSubtitle}
                            className="subtitle-wrapper"
                        >
                            <h4>
                                {
                                    content.contentNextChapter
                                        .contentNextChapterSubTitle
                                }
                            </h4>
                        </motion.div>
                    )}
                    {content.contentNextChapter?.contentNextChapterTitle && (
                        <motion.div
                            initial="hidden"
                            animate={chapterAnimationControls}
                            variants={chapterTitle}
                            className="title-wrapper"
                        >
                            <h2>
                                {
                                    content.contentNextChapter
                                        .contentNextChapterTitle
                                }
                            </h2>
                        </motion.div>
                    )}
                    {content.contentNextChapter?.contentNextChapterTitle && (
                        <div className="link-wrapper">
                            <a
                                href={
                                    content.contentNextChapter
                                        .contentNextChapterHref
                                }
                            >
                                <motion.span
                                    initial="hidden"
                                    animate={chapterAnimationControls}
                                    variants={chapterLink}
                                >
                                    Start Next Chapter
                                </motion.span>
                                <motion.div
                                    initial="hidden"
                                    animate={chapterAnimationControls}
                                    variants={chapterArrow}
                                    style={{ originX: 0 }}
                                >
                                    <IconArrow />
                                </motion.div>
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </StyledNextChapter>
    )
}

export default NextChapter
